import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class BonusService {
  public customer: CustomerModel;

  constructor(
    private webservices: WebservicesService,
    private configService: ConfigService,
    private userSession: UserSessionService
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    )
  }

  callGetBonusOffers() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.get('rewards/get-bonus-offers', obj);
  }

  callBonusOfferOptIn(definition_id: string) {
    let obj: any = {
      campaign_definition_id: definition_id,
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.post('rewards/bonus-offer-opt-in', obj);
  }

  callGetCustomerCasinoBonusesActive() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.get('rewards/get-customer-casino-bonuses-active', obj);
  }

  callGetCustomerCasinoBonusesHistory(dateFrom: string, dateTo: string, page?: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
    }

    if (dateFrom) {
      obj.date_from = dateFrom;
    }

    if (dateTo) {
      obj.date_to = dateTo;
    }

    if (page) {
      obj.page = page;
    }

    return this.webservices.get('rewards/get-customer-casino-bonuses-history', obj);
  }

  callForfeitBonus(bonus_id: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_id: bonus_id
    }

    return this.webservices.get('rewards/forfeit-bonus', obj);
  }

  callGetBonusDetails(bonus_id: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_id: bonus_id
    }

    return this.webservices.get('rewards/get-bonus-details', obj);
  }

  callRedeemBonus(bonus_code: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      bonus_code: bonus_code
    }

    return this.webservices.get('rewards/redeem-bonus', obj);
  }

  callValidateBonus(bonus_code: string) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      campaign_code: bonus_code
    }

    return this.webservices.post('rewards/validate-campaign-code', obj);
  }

  callGetBonusFreeSpins() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }

    return this.webservices.get('rewards/get-bonus-free-spins', obj);
  }

  getUrl(gameparams): string {
    //console.log(gameparams)
    let iframeUrl = '';
    let config = this.configService.getConfig();
    let html5Url = config.HTML5_BASEURL;
    let webserviceUrl = this.configService.getEnv().webservices_url;
    let params = new URLSearchParams();
    let cacheBuster = new Date().getTime();
    let WinningOptions = gameparams.winning_options;
    //Adjust some params as Game expects data little differently
    //winningOptions = modifyWinningOptions
    let modifyWinningOptions = WinningOptions.replaceAll(".00","");
    let WinningIndex = gameparams.spin_grant;
    let modifyWinningIndex = WinningIndex.toString();
    let holdWinningOptionArray =  modifyWinningOptions.split(',');
    //winningIndex = setWinningIndexParams
    let setWinningIndexParams = holdWinningOptionArray.indexOf(modifyWinningIndex)

    //console.log(WinningOptions)
    //console.log(modifyWinningOptions)
    //console.log(WinningIndex)
    params.set('winningOptions', modifyWinningOptions );
    params.set('winningIndex', setWinningIndexParams );
    params.set('htmlBaseUrl', config.HTML5_BASEURL );
    iframeUrl = `${html5Url}/dailywheel/web/stardust/index.html?` + params.toString() + `&v=${cacheBuster}`;
    return iframeUrl;
  }
}
